import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MedicalLetterService } from '../../../../services/medical-letter/medical-letter-service';
import { MedicalLetterDto } from '../../../../models/medical-letter/medical-letter-dto';

export class MedicalLetterEmployeeDatabase {
    /** Stream that emits whenever the data has been modified. */
    dataChange: BehaviorSubject<MedicalLetterDto[]> = new BehaviorSubject<MedicalLetterDto[]>([]);

    get data(): MedicalLetterDto[] {
        return this.dataChange.value;
    }

    constructor(
        private medicalLetterService: MedicalLetterService,
        private employeeId: string
    ) {
        setTimeout(() => {
            this.medicalLetterService.getAllByEmployeeId(employeeId).subscribe(response => {
                console.log('EmployeeService > response', response);
                for (const r of response) {
                    this.add(   r);
                }
            }, () => {

            });
        }, 100);
    }

    public add(store: MedicalLetterDto) {
        const copiedData = this.data.slice();
        copiedData.push(store);
        this.dataChange.next(copiedData);
    }

    public edit(store: MedicalLetterDto) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData[index] = store;
        this.dataChange.next(copiedData);
    }

    public delete(store: MedicalLetterDto) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData.splice(index, 1);
        this.dataChange.next(copiedData);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/medical-letter/medical-letter-employee-database.ts